import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b8e7dd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "picklist-detail" }

import Loading from '@/components/Loading.vue';
import ErrorComp from '@/components/Error.vue';
import PicklistDetail from '@/components/Picklist/PicklistDetail.vue';
import pinia from '@/plugins/pinia';
import {doConfirm} from '@/util';
import Picklist, {ApiPicklistState, ApiPicklistType} from '@/model/Picklist';
import useDetailPicklist from '@/store/detailPicklist';
import {useStorage} from '@/composables/storage';
import {onBeforeRouteLeave, useRoute} from 'vue-router';
import {usePicklistPickerStore} from '@/store/picklistPickerV2';
import moment from 'moment/moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'PicklistDetail',
  setup(__props, { expose: __expose }) {

const picklistPicker = usePicklistPickerStore(pinia);
const store = useDetailPicklist();
const route = useRoute();
useStorage(
    store,
    (picklist) => picklist ? `Pickliste ${picklist?.Picklistnr}` : 'Pickliste',
  route.params.id !== '-1' ? (route) => ({Picklistnr: route.params.id as string}) : null,
  async () => {
    try {
      if (route.params.id === '-1') {
        const picklist = Picklist.fromApi({
          Art: ApiPicklistType.Order,
          Picklistnr: '-1',
          BestellNr: null,
          KundenNr: Number(route.query.kunde as string),
          Erstelltam: moment().format('YYYY-MM-DD'),
          Erstelltdurch: '',
          Status: ApiPicklistState.Todo,
          Kmsdatum: route.query.lieferdatum as string,
          Kmsuhrzeit: '',
          Kmsprioritaet: '',
          Kmsam: route.query.lieferdatum as string,
          Kmsdurch: '',
          Kmsbediener: null,
          Tour: [],
          Auftraege: [],
          InterneAuftraege: [],
        });
        await picklistPicker.edit(picklist);
      } else {
        await picklistPicker.edit();
      }
    } catch (err) {
      console.error(err);
    }
  },
);

onBeforeRouteLeave(async (_to, _from, next) => {
  if (picklistPicker.picklist?.Status === ApiPicklistState.Active) {
    if (picklistPicker.addedItems > 0 && await doConfirm('Aktuelle Pickliste parken?', 'Parken?')) {
      await picklistPicker.park();
    } else if (await doConfirm('Aktuelle Pickliste verwerfen?', 'Verwerfen?')) {
      await picklistPicker.cancel();
    } else {
      next(false);
      return;
    }
  }

  if (picklistPicker.picklist?.Picklistnr === '-1' && picklistPicker.picklist?.Status === ApiPicklistState.Todo) {
    if (await doConfirm('Soll die Anlage der Pickliste wirklich abgebrochen werden?', 'Wirklich abbrechen?')) {
      next();
      return;
    } else {
      next(false);
      return;
    }
  }

  next();
});

__expose({
  Loading,
  Error: ErrorComp,
  PicklistDetail,
  store,
  picklistPicker,
});

return (_ctx: any,_cache: any) => {
  const _component_error = _resolveComponent("error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(store).error && !_unref(store).loading)
      ? (_openBlock(), _createBlock(PicklistDetail, {
          key: 0,
          data: _unref(store).data,
          ref: "picklistDetail",
          modelValue: _unref(picklistPicker).selectedPosition,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(picklistPicker).selectedPosition) = $event))
        }, null, 8, ["data", "modelValue"]))
      : _createCommentVNode("", true),
    (_unref(store).error)
      ? (_openBlock(), _createBlock(_component_error, {
          key: 1,
          module: _unref(store).$id
        }, null, 8, ["module"]))
      : _createCommentVNode("", true),
    (_unref(store).loading)
      ? (_openBlock(), _createBlock(Loading, { key: 2 }))
      : _createCommentVNode("", true)
  ]))
}
}

})